module.exports = __webpack_public_path__ + "static/media/google_meet_no_extension.ccfee3f9.png";